export default __webpack_public_path__ + "static/media/4 - Beach on Spruce Island.ac3aecda.jpeg";